import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import * as NewMessageActions from 'web-app/react/inbox/new-conversation/actions';

import * as Actions from './actions';

const closeOnSend = action$ =>
    action$.ofType(NewMessageActions.sendSuccess.type).mergeMap(() => Observable.of(Actions.hide.action()));

export default combineEpics(closeOnSend);
